import { render, staticRenderFns } from "./Create-Company.vue?vue&type=template&id=3578b2fe&scoped=true"
import script from "./Create-Company.vue?vue&type=script&lang=js"
export * from "./Create-Company.vue?vue&type=script&lang=js"
import style0 from "./Create-Company.vue?vue&type=style&index=0&id=3578b2fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3578b2fe",
  null
  
)

export default component.exports